{
  "Clear search": "مسح البحث"
}
